var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"entry"},[(_vm.initialized && _vm.ready && _vm.loaded && _vm.entry)?_c('blog-entry',_vm._b({attrs:{"fullMode":true,"links":_vm.entry.links}},'blog-entry',_vm.entry,false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }